// src/utils/pincode.js

import axios from 'axios';

const pinCodeCache = {};

// Helper to get/set from localStorage
const localStorageKey = 'hawler_pincode_coordinates';

function loadLocalCache() {
  try {
    const data = localStorage.getItem(localStorageKey);
    return data ? JSON.parse(data) : {};
  } catch {
    return {};
  }
}

function saveLocalCache(cache) {
  try {
    localStorage.setItem(localStorageKey, JSON.stringify(cache));
  } catch {}
}

export const getCoordinatesFromPin = async (pinCode) => {
  if (pinCodeCache[pinCode]) {
    return pinCodeCache[pinCode];
  }

  // Check localStorage cache
  const localCache = loadLocalCache();
  if (localCache[pinCode]) {
    pinCodeCache[pinCode] = localCache[pinCode];
    return localCache[pinCode];
  }

  try {
    // Use Nominatim OpenStreetMap API to get coordinates
    const response = await axios.get('https://nominatim.openstreetmap.org/search', {
      params: {
        postalcode: pinCode,
        country: 'India',
        format: 'json',
        limit: 1,
      },
    });

    if (response.data && response.data.length > 0) {
      const location = response.data[0];
      const latitude = parseFloat(location.lat);
      const longitude = parseFloat(location.lon);

      if (!isNaN(latitude) && !isNaN(longitude)) {
        const coordinates = { lat: latitude, lon: longitude };
        pinCodeCache[pinCode] = coordinates; // In-memory cache
        localCache[pinCode] = coordinates; // LocalStorage cache
        saveLocalCache(localCache);
        return coordinates;
      }
    }

    throw new Error("Invalid pin code");
  } catch (error) {
    throw error;
  }
};
